import { useQuery } from "@tanstack/react-query";
import { authApi } from "@/features/auth/api/auth.api";
export const useAuth = () => {
  const { data, isLoading, isSuccess, isError, error } = useQuery({
    queryKey: ["auth", "me"],
    queryFn: authApi.getSession,
    retry: false,
    staleTime: 1000 * 60 * 5,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
  });

  return {
    data,
    isLoading,
    isSuccess,
    isError,
    error,
  };
};
